const isSSR = process.title !== "browser";
export default isSSR;
